









 
import { useEffect, useState } from "react";
import {
  getSubtasksApi,
  addSubtaskApi,
  toggleSubtaskApi,
  addSubtaskDependencyApi,
  updateSubtaskApi,
  deleteSubtaskApi
} from "../../app/api";
 
export default function TaskSubtasks({ taskId, onProgressChange, onSubtaskUpdate }) {
 
 
  const [startDate, setStartDate] = useState("");
  const [subtasks, setSubtasks] = useState([]);
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const [openMenu, setOpenMenu] = useState(null);
 
  const total = subtasks.length;
  const completed = subtasks.filter((s) => s.is_done).length;
  const [showModal, setShowModal] = useState(false);
  const [selectedParent, setSelectedParent] = useState(null);
  const [selectedChildren, setSelectedChildren] = useState([]);
  const [editSubtask, setEditSubtask] = useState(null);
  const [editTitle, setEditTitle] = useState("");
  const [editDate, setEditDate] = useState("");

  const handleUpdateSubtask = async () => {
    if (!editSubtask) return;
  
    try {
      await updateSubtaskApi(editSubtask.id, {
        title: editTitle,
        start_date: editDate,
      });
  
      setEditSubtask(null);
      setEditTitle("");
      setEditDate("");
  
      fetchSubtasks();
  
      // ✅ refresh parent
      onSubtaskUpdate?.(taskId);
  
    } catch (err) {
      console.error("Update error:", err);
    }
  };

  const handleDeleteSubtask = async (subtask) => {
    if (!window.confirm(`Delete "${subtask.title}"?`)) return;
    try {
      await deleteSubtaskApi(subtask.id);
      onSubtaskUpdate?.(taskId);
      fetchSubtasks();
    } catch (err) {
      console.error("Delete error:", err);
    }
  };
 
  const handleSubmitDependency = async () => {
    if (!selectedParent || selectedChildren.length === 0) {
      alert("Select parent and children tasks");
      return;
    }
 
    try {
      for (let childId of selectedChildren) {
        if (childId !== Number(selectedParent)) {
          await addSubtaskDependencyApi(childId, {
            depends_on_subtask_id: selectedParent,
          });
        }
      }
 
      const refreshed = await getSubtasksApi(taskId);
      setSubtasks(refreshed.data || []);
 
      setShowModal(false);
      setSelectedChildren([]);
      setSelectedParent(null);
 
    } catch (err) {
      console.error("Dependency error", err);
    }
  };
 
 
  /* ================= FETCH SUBTASKS ================= */
  const fetchSubtasks = async () => {
    if (!taskId) return;
 
    setLoading(true);
    try {
      const res = await getSubtasksApi(taskId);
      // const list = (res.data || []).sort((a, b) => a.id - b.id);
 
      const today = new Date().toISOString().split("T")[0];
 
const list = (res.data || []).sort((a, b) => {
  const aDateTime = new Date(a.start_date || a.created_at);
  const bDateTime = new Date(b.start_date || b.created_at);
 
  // ✅ STRICTLY BY DATE (DESCENDING)
  return bDateTime - aDateTime;
});
 
      setSubtasks(list);
 
      onProgressChange?.({
        total: list.length,
        completed: list.filter((s) => s.is_done).length,
      });
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };
 
 
 
 
  useEffect(() => {
    fetchSubtasks();
  }, [taskId]);
 
  /* ================= ADD SUBTASK ================= */
  const addSubtask = async () => {
    if (!title.trim()) return;
 
    await addSubtaskApi(taskId, { title, start_date: startDate, });
 
// ✅ ADD THIS LINE
onSubtaskUpdate?.(taskId);
 
 
    setTitle("");
    setStartDate(""); // reset
 
    fetchSubtasks();
  };
 
  /* ================= TOGGLE SUBTASK ================= */
  const toggleSubtask = async (subtask) => {
    try {
      await toggleSubtaskApi(subtask.id, {
        is_done: !subtask.is_done,
      });
  // ✅ ADD THIS LINE
  onSubtaskUpdate?.(taskId);
      fetchSubtasks();
    } catch (err) {
      console.error("Toggle error:", err);
    }
  };
 
  /* ================= ADD DEPENDENCY ================= */
  const addDependency = async (subtaskId, dependsOnId) => {
    try {
      await addSubtaskDependencyApi(subtaskId, {
        depends_on_subtask_id: dependsOnId,
      });
 
      fetchSubtasks();
      setOpenMenu(null);
    } catch (err) {
      console.error("Dependency error:", err);
    }
  };
 
  if (loading) {
    return (
      <div className="text-sm text-gray-400">
        Loading subtasks…
      </div>
    );
  }
 
 
 
  const groupedSubtasks = subtasks.reduce((acc, sub) => {
  const date =
    (sub.start_date || sub.created_at)?.split(" ")[0];
 
  if (!acc[date]) {
    acc[date] = [];
  }
 
  acc[date].push(sub);
  return acc;
}, {});
 
  return (
    <div className="mt-6">
      <h3 className="font-semibold mb-6">Subtasks</h3>
 
      {/* ===== PROGRESS BAR ===== */}
      {total > 0 && (
        <div className="mb-4">
          <div className="flex justify-between text-xs text-white mb-1">
            <span>{completed} / {total} done</span>
            <span>{Math.round((completed / total) * 100)}%</span>
          </div>
 
          <div className="h-1.5 bg-gray-200 rounded overflow-hidden">
            <div
              className="h-full bg-blue-600 transition-all duration-300"
              style={{ width: `${(completed / total) * 100}%` }}
            />
          </div>
 
          {completed === total && (
            <div className="mt-2 text-xs text-green-700 bg-green-50 border border-green-200 rounded px-2 py-1">
              All subtasks completed. You can move this task forward.
            </div>
          )}
        </div>
      )}
 
      {/* ===== SUBTASK LIST ===== */}
      <div className="flex flex-col gap-2">
        {subtasks.map((sub) => {
          const dependency = subtasks.find(
            (s) => s.id === sub.depends_on_subtask_id
          );
 
          const isLocked =
            dependency && !dependency.is_done;
 
          return (
            <div
              key={sub.id}
              className="flex items-center justify-between text-sm relative"
            >
              {/* LEFT SIDE */}
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={!!sub.is_done}
                  disabled={isLocked}
                  onChange={() =>
                    !isLocked && toggleSubtask(sub)
                  }
                />
 
                {/* <span
                  className={
                    sub.is_done
                      ? "line-through text-gray-400"
                      : isLocked
                      ? "text-gray-400"
                      : ""
                  }
                >
                  {sub.title}
                </span> */}
 
 
<div className="flex flex-col">
  <span
    className={
      sub.is_done
        ? "line-through text-gray-400"
        : isLocked
        ? "text-gray-400"
        : ""
    }
  >
    {sub.title}
  </span>
 
  {/* ✅ START DATE DISPLAY */}
  <span className="text-[11px] text-gray">
  Start: {(sub.start_date || sub.created_at)?.split(" ")[0]}
</span>
</div>
 
                {isLocked && (
                  <span className="text-[10px] bg-orange-100 text-orange-700 px-2 py-0.5 rounded">
                    🔒 Locked
                  </span>
                )}
              </div>
 
              {/* RIGHT SIDE - THREE DOT MENU */}
              <div className="relative">
               
 
{/* <button onClick={() => setShowModal(true)}>
  ⋮
</button> */}


<div className="flex items-center gap-2">
  {/* ✏️ EDIT ICON */}
  <button
    onClick={() => {
      setEditSubtask(sub);
      setEditTitle(sub.title);
      setEditDate((sub.start_date || "").split(" ")[0]);
    }}
    className="text-blue-500 hover:text-blue-700"
    title="Edit subtask"
  >
    ✏️
  </button>

  {/* 🗑️ DELETE ICON */}
  <button
    onClick={() => handleDeleteSubtask(sub)}
    className="text-red-500 hover:text-red-700"
    title="Delete subtask"
  >
    🗑️
  </button>

  {/* EXISTING MENU */}
  <button onClick={() => setShowModal(true)}>
    ⋮
  </button>
</div>
 
                {openMenu === sub.id && (
                  <div className="absolute right-0 mt-1 bg-white border rounded shadow-md p-2 text-xs w-52 z-10">
                   
                    <div className="font-semibold mb-1">
                      Set Dependency
                    </div>
 
                    {/* Show current dependency */}
                    {dependency && (
                      <div className="mb-2 text-green-600">
                        Depends on: {dependency.title}
                      </div>
                    )}
 
                    {/* Allow selecting dependency only if none exists */}
                    {!sub.depends_on_subtask_id &&
                      subtasks
                        .filter((s) => s.id !== sub.id)
                        .map((s) => (
                          <div
                            key={s.id}
                            className="cursor-pointer hover:bg-gray-100 p-1 rounded"
                            onClick={() =>
                              addDependency(sub.id, s.id)
                            }
                          >
                            Depends on: {s.title}
                          </div>
                        ))}
 
                    {!sub.depends_on_subtask_id &&
                      subtasks.length <= 1 && (
                        <div className="text-gray-400">
                          No other subtasks available
                        </div>
                      )}
                  </div>
                )}
              </div>
            </div>
          );
        })}
 
 
 
 
 
 
       
      </div>
 
      {/* ===== ADD SUBTASK ===== */}
      <div className="flex gap-2 mt-3 text-black">
        <input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Add subtask"
          className="flex-1 border rounded px-2 py-1 text-sm text-black "
        />
 
 
       
 
        <button
          onClick={addSubtask}
          className="px-3 py-1 bg-blue-600 text-white rounded text-sm"
        >
          Add
        </button>
      </div>
 
 
 
 
 
      {showModal && (
  // <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center">
  <div className="fixed inset-0 z-[10000] bg-black/40 flex justify-center items-center">
    {/* <div className="bg-white p-4 rounded w-96"> */}
    <div className="bg-white p-5 rounded-lg w-96 text-black shadow-xl">
 
      <h3 className="font-semibold mb-3">Create Dependency</h3>
 
      {/* DROPDOWN */}
      <select
        className="w-full border p-2 mb-3"
        onChange={(e) => setSelectedParent(e.target.value)}
      >
        <option value="">Select Parent Task</option>
        {subtasks.map((s) => (
          <option key={s.id} value={s.id}>
            {s.title}
          </option>
        ))}
      </select>
 
      {/* CHILD CHECKBOX LIST */}
      <div className="max-h-40 overflow-y-auto mb-3">
        {subtasks.map((s) => (
          <label key={s.id} className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={selectedChildren.includes(s.id)}
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedChildren([...selectedChildren, s.id]);
                } else {
                  setSelectedChildren(
                    selectedChildren.filter(id => id !== s.id)
                  );
                }
              }}
            />
            {s.title}
          </label>
        ))}
      </div>
 
      {/* BUTTON */}
      <button
        onClick={handleSubmitDependency}
        className="bg-blue-600 text-white px-3 py-1 rounded"
      >
        Submit
      </button>
 
      <button
        onClick={() => setShowModal(false)}
        className="ml-2 text-gray-500"
      >
        Cancel
      </button>
 
    </div>
  </div>
)}
 
 
 {editSubtask && (
  <div className="fixed inset-0 z-[10000] bg-black/40 flex justify-center items-center">
    <div className="bg-white p-5 rounded-lg w-96 text-black shadow-xl">

      <h3 className="font-semibold mb-3">Edit Subtask</h3>

      <input
        value={editTitle}
        onChange={(e) => setEditTitle(e.target.value)}
        className="w-full border p-2 mb-3"
        placeholder="Subtask title"
      />

      {/* <input
        type="date"
        value={editDate}
        onChange={(e) => setEditDate(e.target.value)}
        className="w-full border p-2 mb-3"
      /> */}

      <button
        onClick={handleUpdateSubtask}
        className="bg-blue-600 text-white px-3 py-1 rounded"
      >
        Update
      </button>

      <button
        onClick={() => setEditSubtask(null)}
        className="ml-2 text-gray-500"
      >
        Cancel
      </button>
    </div>
  </div>
)}
 
    </div>
  );
}
 
 
 
 
//     </div>
//   );
// }
 
 




